import { render, staticRenderFns } from "./ifoot.vue?vue&type=template&id=36ca3f42&"
import script from "./ifoot.vue?vue&type=script&lang=js&"
export * from "./ifoot.vue?vue&type=script&lang=js&"
import style0 from "./ifoot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports